require('./newsletter');
require('./cookies');



// WEBPACK FOOTER //
// ./resources/assets/js/modules/index.js